import useProcessDicomFiles from '~/hooks/useProcessDicomFiles';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import LocalFilesUploadButton from './LocalFilesUploadButton';

const LocalFilesExplorerTab = () => {
    const { initializeEnvironment } = useViewportEnvironment();
    const { processImportedFiles } = useProcessDicomFiles();

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.target.files && e.target.files[0]) {
            const files = Array.from(e.target.files);
            const processedItems = await processImportedFiles(files);
            if (processedItems) initializeEnvironment(processedItems);
        }
    };
    return <LocalFilesUploadButton onFilesChange={handleFileChange} />;
};

export default LocalFilesExplorerTab;
